import React from 'react';

import DocLink from './DocLink';
import List from '../../../components/shared/List';
import { SizeType } from '../../../types';

type Link = {
  href: string;
  title: string;
  appId?: string;
};

type DocLinksProps = {
  /** Docs to link */
  links: Link[];
  /** Size to display. */
  size?: SizeType;
};

/** Renders a list of docs. */
const DocLinks = ({ links, size = 'large' }: DocLinksProps) => (
  <List
    gap={5}
    itemRenderer={(item: Link) => <DocLink {...item} size={size} />}
    items={links}
  />
);

export default DocLinks;
